var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.32,0A27.32,27.32,0,1,0,54.64,27.32,27.32,27.32,0,0,0,27.32,0Zm.94,43h0A2.32,2.32,0,0,1,25,39.7a2.36,2.36,0,0,1,3.29,0,2.35,2.35,0,0,1,0,3.29ZM38,19.12a8.23,8.23,0,0,1-.86,3.26,14.44,14.44,0,0,1-2.64,3.74l-2.85,2.93a14.88,14.88,0,0,0-2.39,3.27,9.63,9.63,0,0,0-.83,2.53l-.11.45a1.7,1.7,0,0,1-1.84,1.22A1.75,1.75,0,0,1,25.17,36a1.35,1.35,0,0,1-.37-1.06,10.49,10.49,0,0,1,1-3.51,13.67,13.67,0,0,1,2.51-3.67l2.84-2.91a16.93,16.93,0,0,0,2.34-3,6.38,6.38,0,0,0,.94-3.27A5.4,5.4,0,0,0,32.52,14a8.19,8.19,0,0,0-5.3-1.58,9.1,9.1,0,0,0-5,1.31,6.49,6.49,0,0,0-2.42,2.72,1.35,1.35,0,0,1-.83.67A1.86,1.86,0,0,1,17.56,17,1.71,1.71,0,0,1,16.78,15a9.29,9.29,0,0,1,3.75-4.17,12.9,12.9,0,0,1,6.69-1.76,11.85,11.85,0,0,1,7.64,2.47A8.68,8.68,0,0,1,38,19.12Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.de8d49833e282f6f16d9e1562779fd8b.svg";
export { ForwardRef as ReactComponent };